// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-9hca","content":"styles_content__2ppRx","checkbox":"styles_checkbox__2Julw","checkboxLabel":"styles_checkboxLabel__1F63D"};